import { ServerResponse } from '.';
import { httpClient } from './config';

export const getAllAppointments = async () => httpClient.get<any, ServerResponse>('/api/appointments');
